import { Link } from "react-router-dom";
import "./NotFoundPage.scss";

export default function NotFoundPage() {
  return (
    <div id="not-found">
      <div className="not-found">
        <div className="not-found-404">
          <h1>404</h1>
        </div>
        <h2>404</h2>
        <p>The page not found </p>
        <Link to="/panel/">Back to main page</Link>
      </div>
    </div>
  );
}
